import { useContext, useState } from 'react'
import Tabing from './tabing'
import { Link, useNavigate } from 'react-router'
import { GlobalContext } from '../../../../../context/Context'
import { Bell, CircleUser, Grid, LogOut, Plus, Settings } from 'lucide-react'
import { CustomDropdown } from '../../../../ui/dropdown/CustomDropdown'
import { CustomDropdownButton } from '../../../../ui/dropdown/CustomDropdownButton'
import { CustomDropdownMenu } from '../../../../ui/dropdown/CustomDropdownMenu'
import { CustomDropdownMenuList } from '../../../../ui/dropdown/CustomDropdownMenuList'
import MainPopup from '../../../../popup/main'
import SettingIcon from '../../../../icons/setting'

const TopHeader = ({ topTabs, style, className }) => {
    let { state, dispatch } = useContext(GlobalContext);
    const route = useNavigate();
    const logOut = () => {
        localStorage.removeItem("tokenV3");
        localStorage.removeItem("userV3");
        dispatch({ type: 'USER_LOGOUT' })
    }
    const navigate = useNavigate()

    const accessRemove = () => {
        localStorage.removeItem('saleToken');
        route('/oprations/setting')
        dispatch({ type: 'SALE_LOGOUT' })
    }
    const [addUser, setAddUser] = useState(false);
    
    return (
        <>
            <div className={`${style.headerTop} ${className?.headerTop}`}>
                <Tabing topTabs={topTabs} style={style} className={className} />

                <div className={`${style.headerTop_right} ${className?.headerTop_right}`}>
                    <div className={`${style.headerTop_right_access} ${className?.headerTop_right_access}`}>
                        <div
                            className="w-full cursor-pointer bg-red-600 text-white text-[12px] py-[10px] px-3 rounded-md hover:bg-red-700 transition shadow-sm"
                            onClick={() => {accessRemove()}}
                        >
                            Remove Access
                        </div>
                    </div>

                    <div className={`${style.headerTop_addButton} ${className?.headerTop_addButton}`} onClick={() => { setAddUser(true) }}>
                        <span className={`${style.headerTop_addBtn} ${className?.headerTop_addBtn}`}>
                            <Plus size={'1em'} />
                        </span>
                    </div>

                    <Link to={"/setting/organization/brands"} className={`${style.headerTop_setting} ${className?.headerTop_setting}`}>
                        <span className={`${style.headerTop_settingBtn} ${className?.headerTop_settingBtn}`}>
                            <SettingIcon />
                        </span>
                    </Link>

                    <div className={`${style.headerTop_notification} ${className?.headerTop_notification}`}>
                        <span className={`${style.headerTop_notificationBtn} ${className?.headerTop_notificationBtn}`}>
                            <Bell size={'1em'} />
                        </span>
                    </div>

                    <CustomDropdown className={`${style.headerTop_profile} ${className?.headerTop_profile}`} position="bottom-right">
                        <CustomDropdownButton arrow={false} className={`${style.headerTop_profileBtn} ${className?.headerTop_profileBtn} !p-0`}>
                            <img width={28} height={28} alt='Pic' src={state?.user?.profile_picture} />
                        </CustomDropdownButton>

                        <CustomDropdownMenu>
                            {/* <CustomDropdownMenuList onClick={() => {navigate("/profile/my-data/overview")}}>
                                <div className={"d-flex align-items-center gap-1 !text-sm"}><CircleUser size={'1em'} /> Profile</div>
                            </CustomDropdownMenuList> */}
                            <CustomDropdownMenuList onClick={() => logOut()}>
                                <div className={"d-flex align-items-center gap-1 !text-sm"}><LogOut size={'1em'} /> LogOut</div>
                            </CustomDropdownMenuList>
                        </CustomDropdownMenu>
                    </CustomDropdown>
                </div>
            </div>


            {addUser &&
                <MainPopup
                    onClose={() => { setAddUser(false); }}
                />
            }
        </>
    )
}

export default TopHeader
